module.exports = __webpack_public_path__ + "static/media/slakteweb-small-icon.8754ff14.png";